import React from "react";
import { Form, Checkbox } from "antd";

import ReloadableImage from "../ReloadableImage";
import { indexOptionDict } from "../../../utils/constants";

import "../shared.css";

export default (field) => {
  return (
    <Form.Item name={[field.id, "value"]} initialValue={field.solution}>
      <Checkbox.Group disabled={field.preview}>
        {field.options.map((option, index) => (
          <Checkbox
            style={{ marginLeft: "0px", display: "block", padding: "10px" }}
            value={option.id}
            key={option.id}
          >
            {option.items.map(({ id, type, value }) => {
              switch (type) {
                case "string":
                  return `${indexOptionDict[index]}. ${value}`;
                case "img":
                  return (
                    <ReloadableImage
                      className="displayImage"
                      value={value}
                      key={id}
                    />
                  );
                default:
                  return null;
              }
            })}
          </Checkbox>
        ))}
      </Checkbox.Group>
    </Form.Item>
  );
};
